import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Select from 'react-select';

//import { Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel } from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';

import { Redirect } from 'react-router-dom';
import { getTokenInfo } from '../../UseToken';

import { object_type, api_crud_base, api_list_route,  api_crud_route, data_interface, endpoints } from './Config';

import 'react-phone-number-input/style.css'

import { confirmAlert } from 'react-confirm-alert';

//import FileUpload from '../FileUpload/FileUpload' ;

import {

	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,
	//reqFILE,
	check_interface,
	set_language,
	content_language,


} from '../../Utils';

import { language } from '../WEBContent/Language';


export default function Regist(props) {

	const [, set_dados] = useState(null);
	const dados = useRef(null);
	//const [reviewers, set_reviewers] = useState([]);
	const [/*editores*/, set_editores] = useState([]);

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);

	const [/*show_vat_form */, set_show_vat_form] = useState('');
	const [show_delete_button, set_show_delete_button] = useState('d-none');

	const [is_edit, set_is_edit] = useState(false)
	//console.log(is_edit)

	const [lang, set_lang] = useState('pt');
    const [, set_lang_id] = useState('1');

	//const [nome_convidado, set_nome_convidado] = useState('')
	//const [area_convidado, set_area_convidado] = useState('')
	//const [instituicao_convidado, set_instituicao_convidado] = useState('')
	//const [descricao_convidado, set_descricao_convidado] = useState('')

	const [/*topicos*/, set_topicos] = useState([])
	//const [nome_topico, set_nome_topico] = useState('')

	//const [nome_cfp, set_nome_cfp] = useState('')
	//const [descricao_cfp, set_descricao_cfp] = useState('')
	//const [data_inicio_cfp, set_data_inicio_cfp] = useState('')
	//const [data_submissao_cfp, set_data_submissao_cfp] = useState('')
	//const [data_limite_fim_cfp, set_data_limite_fim_cfp] = useState('')
	//const [data_material_suplementar_cfp, set_data_material_suplementar_cfp] = useState('')
	//const [data_resposta_revisao_cfp, set_data_resposta_revisao_cfp] = useState('')
	//const [data_limite_edicao_cfp, set_data_limite_edicao_cfp] = useState('')	
	//const [data_decisao_final_revisor_cfp, set_data_decisao_final_revisor_cfp] = useState('')
	//const [data_final_processo_cfp, set_data_final_processo_cfp] = useState('')

	//const [topico_selected, set_selected_topico] = useState({label: '', value: ''})
	//const [editor_selected, set_selected_editor] = useState({label: '', value: ''})

	const [/*avaliable_file*/, set_avaliable_file] = useState([])
	const [/*avaliable_lang*/, set_avaliable_lang] = useState([])

	//const [pergunta, set_pergunta] = useState('')

	//const [file_name, set_file_name] = useState([]);

	//const [refresh, setRefresh] = useState(0);

	//const articles = useRef([]);

    //const reviewers = useRef([]);


	const custom_select_styles = {
		container: base => ({
			...base,
			width: '100%',
		}),
		control: base => ({
			...base,
			borderRadius: "10px",
			padding: "2px 10px",
			fontSize: '14px'
		}),
	}

	
	//let today = newDate.getFullYear() + '-' + (newDate.getMonth() + 1).toString().padStart(2, "0") + '-' + newDate.getDate().toString().padStart(2, "0");

	const change_tipo = e => {
		set_dados(dados.current.info.tipo = e.value);
		set_dados(dados)
	}

	let compareDataWithInterface = (data, d_interface) => { 

		data.id = check_interface(data.id, d_interface.id)
		data.info = check_interface(data.info, d_interface.info)
		data.info.companycode = check_interface(data.info.companycode, d_interface.info.companycode)
		data.info.unique_code = check_interface(data.info.unique_code , d_interface.info.unique_code)
		data.info.name = check_interface(data.info.name , d_interface.info.name)
		data.info.tipo = check_interface(data.info.tipo , d_interface.info.tipo)
		data.info.description = check_interface(data.info.description , d_interface.info.description)

		data.info.cfp = check_interface(data.info.cfp , d_interface.info.cfp)


		//Não utilizado no call for paper para não criar logo um cfp vazio no registo de um evento
		/*data.info.cfp.forEach(v => { 

			v.id = check_interface(v.id, d_interface.info.cfp[0].id)
			v.nome = check_interface(v.nome, d_interface.info.cfp[0].nome)
			v.descricao = check_interface(v.descricao, d_interface.info.cfp[0].descricao)
			v.data_inicio = check_interface(v.data_inicio, d_interface.info.cfp[0].data_inicio)
			v.data_submissao = check_interface(v.data_submissao, d_interface.info.cfp[0].data_submissao)
			v.data_limite_fim = check_interface(v.data_limite_fim, d_interface.info.cfp[0].data_limite_fim)
			v.data_marerial_suplementar = check_interface(v.data_marerial_suplementar, d_interface.info.cfp[0].data_marerial_suplementar)
			v.data_resposta_revisao = check_interface(v.data_resposta_revisao, d_interface.info.cfp[0].data_resposta_revisao)
			v.data_limite_edicao_artigo = check_interface(v.data_limite_edicao_artigo, d_interface.info.cfp[0].data_resposta_revisao)
			v.data_decisao_final_revisor = check_interface(v.data_decisao_final_revisor, d_interface.info.cfp[0].data_decisao_final_revisor)
			v.data_final_processo = check_interface(v.data_final_processo, d_interface.info.cfp[0].data_final_processo)



		})*/

		data.info.topicos = check_interface(data.info.topicos , d_interface.info.topicos)
		data.info.convidados = check_interface(data.info.convidados , d_interface.info.convidados)
		data.info.editores = check_interface(data.info.editores , d_interface.info.editores)

		data.info.reviewers = check_interface(data.info.reviewers , d_interface.info.reviewers)
		data.info.reviewers.max_articles = check_interface(data.info.reviewers.max_articles , d_interface.info.reviewers.max_articles)
		data.info.reviewers.submit = check_interface(data.info.reviewers.submit , d_interface.info.reviewers.submit)
		data.info.reviewers.atribuition_type = check_interface(data.info.reviewers.atribuition_type , d_interface.info.reviewers.atribuition_type)
		data.info.reviewers.questions_visible_to_authors = check_interface(data.info.reviewers.questions_visible_to_authors , d_interface.info.reviewers.questions_visible_to_authors)
		data.info.reviewers.questions = check_interface(data.info.reviewers.questions , d_interface.info.reviewers.questions)

		data.info.authores = check_interface(data.info.authores , d_interface.info.authores)
		data.info.authores.max_articles = check_interface(data.info.authores.max_articles , d_interface.info.authores.max_articles)

		data.info.articles = check_interface(data.info.articles , d_interface.info.articles)
		data.info.articles.max_reviewers_article = check_interface(data.info.articles.max_reviewers_article , d_interface.info.articles.max_reviewers_article)
		data.info.articles.review_type = check_interface(data.info.articles.review_type , d_interface.info.articles.review_type)
		data.info.articles.file_type = check_interface(data.info.articles.file_type , d_interface.info.articles.file_type)
		data.info.articles.linguas = check_interface(data.info.articles.linguas , d_interface.info.articles.linguas)
		data.info.articles.template = check_interface(data.info.articles.template , d_interface.info.articles.template)

		data.profile = check_interface(data.profile, d_interface.profile)

		//console.log('RES DATA EVENTO: ', data)
		//console.log('DATA INTERFACE EVENTO: ', d_interface)

	}
	/*const fetch_id_info = async (id_serch) => {

		let list_route = api_list_route(getTokenInfo().companycode)
		//console.log(list_route)
		//return await reqGET(`${api_crud_route}/${id_serch}`)
		return await reqGET(`${list_route}/${id_serch}`)
			.then(res => {
				compareDataWithInterface(res.data[0], dados.current)
				set_dados(dados.current = res.data[0]);
			})
			.catch(error => error)
	}*/

	// PARA INSTANCIAR O COMPONENTE COM O ID 

	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		set_dados(dados.current.info.office = getTokenInfo().office)
		//console.log(dados.current)
	}

	useEffect(() => {
		get_topicos()
		get_editores()

		if(localStorage.getItem('lang') === undefined  || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_language('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if(el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })
        }

		set_avaliable_file(['pdf', 'doc']);
		set_avaliable_lang(['Português', 'Inglês', 'Espanhol', 'Francês']);

		/* const get_articles = async (id) => {

			let aArticles = [];
	
			
			return await reqGET(`${api_crud_base}/submissions/${getTokenInfo().companycode}/list`)
				.then(res => {
					//console.log(res.data)
					res.data.forEach(x => {
						let aux = { id: x.id, title: x.info.title, cfp: x.info.id_cfp, reviewers: reviewers }
	
						if(x.info.id_cfp === id){
							aArticles.push(aux);
						}
					});
					return aArticles
				})
	
				.catch(erro => { console.log(erro); alert('Erro'); })
		}
 		*/

		clean_data();

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {
				set_is_edit(true)
				//if (props.location.state !== undefined) {
				//console.log('->>>>>>>>>>>>>>>>:' + props.location.state.operation)
				//if (props.location.state.operation === 'edit') {
				set_show_vat_form('d-none')
				set_show_delete_button('')
				//console.log('AQUI DENTRO DO STATE')
				//fetch_id_info(props.location.state.item['id']).then(async() => {

				const fetch_id_info = async (id_serch) => {

					let list_route = api_list_route(getTokenInfo().companycode)
					//console.log(list_route)
					//return await reqGET(`${api_crud_route}/${id_serch}`)
					return await reqGET(`${list_route}/${id_serch}`)
						.then(res => {
							compareDataWithInterface(res.data[0], dados.current)
							set_dados(dados.current = res.data[0]);

							//console.log('RES DATA EVENTO/CFP: ', data)
							//console.log('DATA INTERFACE EVENTO/CFP: ', d_interface)
						})
						.catch(error => error)
				}

				fetch_id_info(props.location.state.item['id_evento']).then(async() => {

					//let lista_revs = await get_reviewers()
					//console.log('lista_revs->', lista_revs)
					//reviewers.current = lista_revs

					//let lista_arts = await get_articles(props.location.state.item['id'])
					//console.log('lista_arts->', lista_arts)
					//articles.current = lista_arts
					//setRefresh(refresh + 1)

					//console.log('++++++++++', articles.current)

					setLoading(false)
				})
			}
		} catch {
			// VAI REGISTAR
			set_show_vat_form('');

			clean_data()

			setLoading(false);

			setRedirect(false);
			return

		}
		// BACK
		//props.history.push(endpoints.list)
		return () => {
			clean_data()
		}

	}, [props])


	const handleSubmit = async e => {
		e.preventDefault();

		if (is_edit === true) {
			//alert('Atualizar PUT')

			confirmAlert({
				title: language[ lang ].edit,
				message: language[ lang ].edit_text ,
				buttons: [
					{
						label: language[ lang ].edit_confirm,
						onClick: () => {

							reqPUT(api_crud_route, dados.current)
								.then(() => { props.history.push(endpoints.list) })
								.catch(() => alert('Problema ao atualizar Registo!'))
						}
					},
					{
						label: language[ lang ].edit_cancel,
						onClick: () => { return }
					}
				]
			})
		} else {
			confirmAlert({
				title: language[ lang ].insert_title ,
				message: language[ lang ].insert_text ,
				buttons: [
					{
						label: language[ lang ].insert_confirm,
						onClick: () => {

							reqPOST(api_crud_route, dados.current)
								.then(() => { props.history.push(endpoints.list) })
								.catch(() => alert('Problema ao inserir Registo!'))
						}
					},
					{
						label: language[ lang ].insert_cancel,
						onClick: () => { return }
					}
				]
			})
		}
	}

	function apagar() {
		confirmAlert({
			title: language[lang].delete_cfp,
			message: language[lang].delete_cfp_text,
			buttons: [
				{
					label: language[lang].delete_confirm,
					onClick: () => {
						// Verificar se existe informação associada ao Cliente
						reqGET(`${api_crud_base}/credits/credits/special/credits/${getTokenInfo().companycode}/${object_type}/${dados.current.id}`).then(
							res => {


								if (res.data.length > 0) {
									confirmAlert({
										title: 'Aviso',
										message: 'A Call For Papers tem registos associados. Apenas pode ser editada.',
										buttons: [
											{
												label: 'Voltar',
												onClick: () => { return }
											}
										]
									})
								} else {
									//alert('Eliminou')

									reqDELETE(api_crud_route + '/', { id: dados.current.id })
										.then(res => {
											/* alert(res.status === 200 ?
												'Registo Apagado com Sucesso' : 'Problema ao Apagar Registo'); 
 											*/
											props.history.push(endpoints.list)
										})
										.catch(error => alert(error))

								}
							}
						)
					}
				},
				{
					label:  language[lang].delete_cancel,
					onClick: () => { return }
				}
			]
		});
	};

	const load_entity = async (vat, entity) => {
		reqGET(`${api_crud_base}/financials/${getTokenInfo().companycode}`)
			.then(res => {
				let ja_existe = false
				res.data.forEach((k) => {
					//console.log(res.data)
					if (k['vat'] === vat) {
						ja_existe = true
					}
				})

				if (ja_existe === false) {
					//<Link to={{ pathname: '/client_regist', state: { item: vat, operation: 'newFromCredit' } }} />

					//console.log('NãO EXISTE ________________>');
					return

				} else {
					confirmAlert({
						title: 'Aviso',
						message: 'Já Existe um Registo com este VAT.',
						buttons: [
							{
								label: 'Voltar',
								onClick: () => { props.history.push(endpoints.list) }
							},

						]
					})

					//console.log(ja_existe);
				}
			}
			)
	}

	const get_topicos = async () => {
		let aTopicos = [];

		reqGET(`${api_crud_base}/topic/${getTokenInfo().companycode}`)
			.then(res => {
				//console.log(res.data)

				res.data.forEach(v => {
					aTopicos.push({ label: v.info.name, value: v.id })
				});
				

				set_topicos(aTopicos)
				//console.log(aTopicos)
			})
			.catch( erro => { console.log( erro ) ; alert( 'Erro' ) ; } )
	}

	const handle_change_info = (e) => {
		const { name, value } = e.target;

		/* DEBUG*/
		/* 
				//console.log('NAME:' + name)
				//console.log('Value:' + value)
		 */
		set_dados(dados.current.info[name] = value)

		if ((is_edit === false) && (name === 'vat')) {
			if (dados.current.info['vat'].length === 9) {
				load_entity(dados.current.info['vat'], object_type)
			}
		}

		/* //console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados)) */

	}

	// Util Functions
	const select_option_util_fun = arg => {
		return( arg.map( k => ( { value : k , label : k } ) ) ) ;
	}

/* 	const handle_change_info_articles = (e) => {
		const { name, value} = e.target;

		// console.log(name)
		// console.log(value)

		set_dados(dados.current.info.articles[name] = value)
        console.log('Dados Current:' + JSON.stringify(dados))
	} */

/* 
	const handle_change_info_reviewers = (e) => {
		const { name, value} = e.target;

		// console.log(name)
		// console.log(value)

		set_dados(dados.current.info.reviewers[name] = value)
        console.log('Dados Current:' + JSON.stringify(dados))
	} */

/* 	const change_reviewers_submit = (e) => {
		const { value } = e;

		set_dados(dados.current.info.reviewers.submit = value)
		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))
	} */

/* 	const change_reviewers_review_type = (e) => {
		const { value } = e;

		set_dados(dados.current.info.articles.review_type = value)
		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))
	} */

/* 	const change_reviewers_atribuition = (e) => {
		const { value } = e;

		set_dados(dados.current.info.reviewers.atribuition_type = value)
		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))
	} */

/* 	const handle_change_info_authores = (e) => {
		const { name, value} = e.target;

		set_dados(dados.current.info.authores[name] = value)
        console.log('Dados Current:' + JSON.stringify(dados))
	} */

/* 	const handle_change_info_convidados = (e) => {
		const { name, value, dataset } = e.target;
		const { index } = dataset;

		set_dados(dados.current.info.convidados[index][name] = value)

		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))
	} */

/* 	const set_novo_convidado = (e) => {
		const { name, value } = e.target;

		if(name === 'convidado_nome')
			set_nome_convidado(value)
		if(name === 'convidado_area')
			set_area_convidado(value)
		if(name === 'convidado_instituicao')
			set_instituicao_convidado(value)
		if(name === 'convidado_descricao')
			set_descricao_convidado(value)
	} */

/* 	const add_convidado = () => {
		
		set_dados(dados.current.info.convidados.push(
			{ 
				nome: nome_convidado,
				area: area_convidado,
				instituicao: instituicao_convidado,
				descricao: descricao_convidado
			}
		));

		set_nome_convidado('')
		set_area_convidado('')
		set_instituicao_convidado('')
		set_descricao_convidado('')


		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))
	} */

/* 	const removeInputConvidado = (index) => {

		let del_value = dados.current.info.convidados.slice(index, index + 1);
		let convidados = dados.current.info.convidados.filter(v => v.nome !== del_value[0].nome);
		console.log(convidados);

		set_dados(dados.current.info.convidados = convidados)
	
		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))

	}; */

/* 	const handle_change_novo_topico = (e) => {
		const { value } = e.target;

		set_nome_topico(value)
	}  */

/* 	const handle_selected_topico = (e) => {
		const { label, value } = e;

		//console.log(label)
		//console.log(value)
		
		set_selected_topico({label: label, value: value })
	} */

/* 	const add_topico = () => {
		//console.log('add_topic')
		//console.log(topico_selected)
		
		let topico = topicos.filter(v => v.label === topico_selected.label);
		if(topico.length === 0) {
			// reqPOST(`${api_crud_base}/topic`, {id: '', info: {name: nome_topico, companycode: '0000000'}})
			// 	.then(() => { get_topicos() })
			// 	.catch(() => alert('Problema ao atualizar Registo!'))
		}
		else {
			set_dados(dados.current.info.topicos.push(
				{ 
					id:  topico_selected.value,
					nome: topico_selected.label
				}
			));
		}

		set_selected_topico({label: '', value: '' })
		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))
	} */

/* 	const add_novo_topico = (e) => {
		let topico = topicos.filter(v => v.label === nome_topico);
		if(topico.length === 0) {
			reqPOST(`${api_crud_base}/topic`, {id: '', info: {name: nome_topico, companycode: '0000000'}})
				.then(() => { get_topicos() })
				.catch(() => alert('Problema ao atualizar Registo!'))
		}
		else {
			//console.log('2')
		}

		set_nome_topico('')
		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))
	} */

/* 	const removeInputTopico = (index) => {

		let del_value = dados.current.info.topicos.slice(index, index + 1);
		let topicos = dados.current.info.topicos.filter(v => v.nome !== del_value[0].nome);
		console.log(topicos);

		set_dados(dados.current.info.topicos = topicos)
	
		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))

	}; */
/* 
	const handle_change_info_topico = (e) => {
		const { name, value, dataset } = e.target;
		const { index } = dataset;

		set_dados(dados.current.info.topicos[index][name] = value)

		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))
	} */

/* 	const handle_selected_editor = (e) => {
		const { label, value } = e;

		//console.log(label)
		//console.log(value)
		
		set_selected_editor({label: label, value: value })
	}
 */
/* 	const add_editor = () => {
		//console.log('add_topic')
		//console.log(topico_selected)
		
		let editor = editores.filter(v => v.label === editor_selected.label);
		if(editor.length === 0) {

		}
		else {
			set_dados(dados.current.info.editores.push(
				{ 
					id:  editor_selected.value,
					name: editor_selected.label
				}
			));
		}

		set_selected_editor({label: '', value: '' })
		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))
	} */

/* 	const removeInputEditor = (index) => {

		let del_value = dados.current.info.editores.slice(index, index + 1);
		let editores = dados.current.info.editores.filter(v => v.id !== del_value[0].id);
		console.log(editores);

		set_dados(dados.current.info.editores = editores)
	
		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))

	}; */

/* 	const handle_change_info_editor = (e) => {
		const { name, value, dataset } = e.target;
		const { index } = dataset;

		set_dados(dados.current.info.editores[index].id = value)

		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))
	} */

/* 	const set_novo_cfp = (e) => {
		const { name, value } = e.target;

		if(name === 'cfp_nome')
			set_nome_cfp(value)
		if(name === 'cfp_descricao')
			set_descricao_cfp(value)
		if(name === 'cfp_data_inicio')
			set_data_inicio_cfp(value)
		if(name === 'cfp_data_submissao')
			set_data_submissao_cfp(value)
		if(name === 'cfp_data_limite_fim')
			set_data_limite_fim_cfp(value)
		if(name === 'cfp_data_material_suplementar')
			set_data_material_suplementar_cfp(value)
		if(name === 'cfp_data_resposta_revisao')
			set_data_resposta_revisao_cfp(value)
		if(name === 'cfp_data_limite_edicao')
			set_data_limite_edicao_cfp(value)
		if(name === 'cfp_data_decisao_final_revisor')
			set_data_decisao_final_revisor_cfp(value)
		if(name === 'cfp_data_final_processo')
			set_data_final_processo_cfp(value)
	} */

/* 	const handle_selected_cfps = (e) => {
		const { label, value } = e;

		//console.log(label)
		//console.log(value)
		
	} */

/* 	const add_cfp = () => {

		if(nome_cfp !== '') {
			set_dados(dados.current.info.cfp.push(
				{ 
					id: dados.current.info.cfp.length + 1,
					name: nome_cfp,
					descricao: descricao_cfp,
					data_inicio: [{
						data: data_inicio_cfp,
						estado: 'activo'
					}],
					data_submissao: [{
						data: data_submissao_cfp,
						estado: 'activo'
					}],
					data_limite_fim: [{
						data: data_limite_fim_cfp,
						estado: 'activo'
					}],
					data_marerial_suplementar: data_material_suplementar_cfp,
					data_resposta_revisao: data_resposta_revisao_cfp,
					data_limite_edicao: data_limite_edicao_cfp,
					data_decisao_final_revisor: data_decisao_final_revisor_cfp,
					data_final_processo: data_final_processo_cfp
				}
			));
		
			set_nome_cfp('')
			set_descricao_cfp('')
			set_data_inicio_cfp('')
			set_data_submissao_cfp('')
			set_data_limite_fim_cfp('')
			set_data_material_suplementar_cfp('')
			set_data_resposta_revisao_cfp('')
			set_data_limite_edicao_cfp('')
			set_data_decisao_final_revisor_cfp('')
			set_data_final_processo_cfp('')
		}

		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))
	}
 */
	/* const removeInputCfp = (index) => {

		let del_value = dados.current.info.cfp.slice(index, index + 1);
		let cfps = dados.current.info.cfp.filter(v => v.nome !== del_value[0].nome);

		set_dados(dados.current.info.cfps = cfps)
	
		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))

	}; */

	const handle_change_info_cfps = (e) => {
		const { name, value, dataset } = e.target;
		const { index } = dataset;

		if(name === 'cfp_data_inicio') {
			set_dados(dados.current.info.cfp[index].data_inicio.forEach((v) => {
				v.estado = ''
			}))
			set_dados(dados.current.info.cfp[index].data_inicio.push({
				data: value,
				estado: 'activo'
			}))
		}
		else if(name === 'cfp_data_submissao') {
			set_dados(dados.current.info.cfp[index].data_submissao.forEach((v) => {
				v.estado = ''
			}))
			set_dados(dados.current.info.cfp[index].data_submissao.push({
				data: value,
				estado: 'activo'
			}))
		}
		else if(name === 'cfp_data_limite_fim') {
			set_dados(dados.current.info.cfp[index].data_limite_fim.forEach((v) => {
				v.estado = ''
			}))
			set_dados(dados.current.info.cfp[index].data_limite_fim.push({
				data: value,
				estado: 'activo'
			}))
		}
		else if(name === 'name') {
			set_dados(dados.current.info.cfp[index].name = value)
		}
		else if(name === 'descricao') {
			set_dados(dados.current.info.cfp[index].descricao = value)
		}

		set_dados(dados.current)
		//setRefresh(refresh + 1)

		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))
	}

	// ////////// ////////// ////////// ////////// ////////// //////////

/* 
	const handle_change_info_reviewers_questions = (e) => {
		const { value, dataset } = e.target;
		const { index } = dataset;

		set_dados(dados.current.info.reviewers.questions[index] = value)

		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))
	} */

/* 	const set_nova_question = (e) => {
		const { value } = e.target;

		set_pergunta(value)
	}

	const add_question = () => {
		
		set_dados(dados.current.info.reviewers.questions.push(
			{ 
				pergunta: pergunta
			}
		));

		set_pergunta('')

		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))
	} */

/* 	const removeInputReviewerQuestion = (index) => {

		let del_value = dados.current.info.reviewers.questions.slice(index, index + 1);
		let perguntas = dados.current.info.reviewers.questions.filter(v => v.pergunta !== del_value[0].pergunta);
		console.log(perguntas);

		set_dados(dados.current.info.reviewers.questions = perguntas)
	
		console.log('«««««««««««««««««««««««')
		console.log('Dados Current:' + JSON.stringify(dados))

	}; */


	/* const get_reviewers = async () => {
		let aReviewers = [];

		reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/Revisor`)
			.then(res => {
				//console.log(res.data)

				res.data.forEach(v => {
					aReviewers.push({ label: v.name + ' ' + v.surname, value: v.id })
				});
				

				set_reviewers(aReviewers)
				//console.log(aReviewers)
			})
			.catch( erro => { console.log( erro ) ; alert( 'Erro' ) ; } )
	} */

	const get_editores = async () => {
		let aEditores = [];

		reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/Editor`)
			.then(res => {
				//console.log(res.data)
 
				res.data.forEach(v => {
					aEditores.push({ label: v.name + ' ' + v.surname, value: v.id })
				});
				

				set_editores(aEditores)
				//console.log(aEditores)
			})
			.catch( erro => { console.log( erro ) ; alert( 'Erro' ) ; } )
	}

/* 	const handleSingleCheckLang = (e) => {
        const { value } = e.target;
        console.log('VALUE', value)

		if(dados.current.info.articles.linguas.length === 0) {
			dados.current.info.articles.linguas.push(value)
		}
		else {
			let aux = dados.current.info.articles.linguas.filter((v) => v !== value)
			if(aux.length === dados.current.info.articles.linguas.length) {
				dados.current.info.articles.linguas.push(value)
			}
			else {
				dados.current.info.articles.linguas = aux
			}
		}

		console.log('Dados Current:' + JSON.stringify(dados))
    } */

/* 	const handleSingleCheck_lang = value => {
		if (dados.current.info.articles.linguas.length !== 0) {
			let tmp = dados.current.info.articles.linguas.filter(k => k === value)
			return tmp.length > 0 ? true : false
		}
		else
			return false
	} */

/* 	const handleSingleCheckFiles = (e) => {
        const { value } = e.target;
        console.log('VALUE', value)

		if(dados.current.info.articles.file_type.length === 0) {
			dados.current.info.articles.file_type.push(value)
		}
		else {
			let aux = dados.current.info.articles.file_type.filter((v) => v !== value)
			if(aux.length === dados.current.info.articles.file_type.length) {
				dados.current.info.articles.file_type.push(value)
			}
			else {
				dados.current.info.articles.file_type = aux
			}
		}

		console.log('Dados Current:' + JSON.stringify(dados))
    } */
	
/* 	const handleSingleCheck_files = value => {
		if (dados.current.info.articles.file_type.length !== 0) {
			let tmp = dados.current.info.articles.file_type.filter(k => k === value)
			return tmp.length > 0 ? true : false
		}
		else
			return false
	} */

/* 	const onChangeHandlerFile = (e) => {
        const { name } = e.target;

        let aux = file_name;
        aux[name] = e.target.files[0].name

        set_file_name(aux)
        setRefresh(refresh + 1)

        handleFileUpload(e);
    } */
/*     const handleFileUpload = event => {
        const files = event.target.files
        const formData = new FormData()
        formData.append('evento', dados.current.info.id)
        formData.append('files', files[0])

        reqFILE(`${api_crud_base}/registration/file`, formData)
            .then((res) => { 

                dados.current.info.article.template.name = res.data.name
                dados.current.info.article.template.link = res.data.path
                dados.current.info.article.template.ext = res.data.ext

                setRefresh(refresh + 1)

                console.log('sucesso POST File')

            })
            .catch(erro => console.log('Erro POST File: ' + erro))
    } */

	// ////////// ////////// ////////// ////////// ////////// //////////

	return isloading ?
		<main>
			<div className={`dash-cards-2 header`}>
				<h2 className="dash-title">LOADING</h2>
				<p>LOADING</p>
				<div className="overlay">
					<div className="overlay__inner">
						<div className="overlay__content"><span className="spinner"></span></div>
					</div>
				</div>
			</div>
		</main>
		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:
			<main>
				<div className={`dash-cards-2 header`}>
					<h2 className="dash-title">Call for Papers</h2>
					<p>{ language[ lang ].home } / Call for Papers / { language[ lang ].edit } Call for Papers</p>
				</div>

				<div className={`dash-cards-2 body`}>
					<div className="card">
						<div className="card-body">
													
							<form id="form" onSubmit={handleSubmit} className="assec-w-100">
								<input type="hidden" name="id" value={dados.current.id} />

								<h2 className="dash-title">{ language[ lang ].events_data }</h2>

								<div className="form-group">
									<span className="flex-2">
										<label>{ language[ lang ].name }</label>
										<input type="text" name="name" value={dados.current.info.name} className="input-form" pattern="[a-zA-Z0-9\u00C0-\u00FF ]+" placeholder="Introduza o nome" onChange={handle_change_info} readOnly/>
									</span>

									<span className={'flex-1'}>
										<label>{ language[ lang ].type }</label>
										<Select
											//className="div-select"
											className="assec-w-100"
											options={ select_option_util_fun( [ 'Conferência' , 'Revista' ] ) }
											name="tipo"
											value={dados.current.info.tipo === '' ? null : { label: dados.current.info.tipo, value: dados.current.info.tipo }}
											placeholder={"Introduza o tipo"}
											onChange={change_tipo}
											styles={custom_select_styles}
											isDisabled
										/>
									</span>
								</div>

								<div className="form-group">
									<span className="flex-2">
										<label>{ language[ lang ].description }</label>
										<textarea name="description" value={dados.current.info.description} className="input-form" rows="4" onChange={handle_change_info} readOnly>
										</textarea>
									</span>
								</div>

								<div className="div-group">
									<div className={dados.current.info.cfp.length > 0 ? 'assec-mt-15' : 'd-none'}>
										<h2 className="dash-title">Call for Papers</h2>
										{
										dados.current.info.cfp.map((elem, index) => {
											if(elem.id !== props.location.state.item['id_cfp'])
												return ''
											else {
												//console.log(elem)
												let aux_data_inicio = elem.data_inicio.filter((v) => v.estado = 'activo').pop()
												let aux_data_submissao = elem.data_submissao.filter((v) => v.estado = 'activo').pop()
												let aux_data_limite_fim = elem.data_limite_fim.filter((v) => v.estado = 'activo').pop()

												let date1 = new Date(elem.data_inicio[elem.data_inicio.length - 1].data)
												let newDate = new Date();
												const editioncfp = (date1 < newDate);
												//console.log('data', date1)
												//console.log('NEW DATE', newDate)

												return(
													<div key={ `${index}` } className="assec-mb-15" >
														<div className="form-group">
															<span className="flex-1">
																<label>{ language[ lang ].name }</label>
																{editioncfp ? (
																	<input
																		type="text" 
																		name ="name"
																		value = { elem.name } 
																		data-index = { index } 
																		onChange={handle_change_info_cfps} 
																		disabled
																	/>
																) : (
																	<input
																		type="text" 
																		name ="name"
																		value = { elem.name } 
																		data-index = { index }
																		onChange={handle_change_info_cfps} 
																	/>
																)}
															</span>
															<span className="flex-1">
															</span>
														</div>
														<div className="form-group">
															<span className="flex-1">
																<label>{ language[ lang ].description }</label>
																<textarea
																	type="text" 
																	name ="descricao"  
																	value = { elem.descricao } 
																	data-index = { index } 
																	rows="4"
																	onChange={handle_change_info_cfps} 
																	readOnly
																/>
															</span>
														</div>
														<div className="form-group">
															<span className="flex-1">
																<label>{ language[ lang ].start_date }</label>
																{editioncfp ? (
																	<input
																		type="date" 
																		name="cfp_data_inicio"  
																		value={ aux_data_inicio.data } 
																		data-index={ index } 
																		onChange={handle_change_info_cfps} 
																		readOnly
																	/>
																) : (
																	<input
																		type="date" 
																		name="cfp_data_inicio"  
																		value={ aux_data_inicio.data } 
																		data-index={ index } 
																		onChange={handle_change_info_cfps} 
																	/>
																)}
															</span>
															<span className="flex-1">
																<label>{ language[ lang ].submission_date }</label>
																<input
																	type="date" 
																	name="cfp_data_submissao"  
																	value={ aux_data_submissao.data } 
																	data-index={ index } 
																	onChange={handle_change_info_cfps} 
																/>
															</span>
															<span className="flex-1">
																<label>{ language[ lang ].end_date }</label>
																<input
																	type="date" 
																	name="cfp_data_limite_fim"  
																	value={ aux_data_limite_fim.data } 
																	data-index={ index } 
																	onChange={handle_change_info_cfps} 
																/>
															</span>
														</div>
														<div className="form-group">
															<span className="flex-1">
																<label>{ language[ lang ].sup_mat_deliv_date }</label>
																<input
																	type="text" 
																	name="data_entrega_material_suplementar"  
																	value={ elem.data_marerial_suplementar } 
																	data-index={ index } 
																	onChange={handle_change_info_cfps} 
																	readOnly
																/>
															</span>
															<span className="flex-1">
																<label>{ language[ lang ].rev_resp_date }</label>
																<input
																	type="text" 
																	name="data_resposta_revisao"  
																	value={ elem.data_resposta_revisao } 
																	data-index={ index } 
																	onChange={handle_change_info_cfps} 
																	readOnly
																/>
															</span>
															<span className="flex-1">
																<label>{ language[ lang ].article_edit_deadline }</label>
																<input
																	type="date" 
																	name="data_limite_edicao_artigo"  
																	value={ elem.data_limite_edicao } 
																	data-index={ index } 
																	onChange={handle_change_info_cfps} 
																	readOnly
																/>
															</span>
														</div>
														<div className="form-group">
															<span className="flex-1">
																<label>{ language[ lang ].rev_fin_dec_date }</label>
																<input
																	type="text" 
																	name="data_decisao_final_revisor"  
																	value={ elem.data_decisao_final_revisor } 
																	data-index={ index } 
																	onChange={handle_change_info_cfps} 
																	readOnly
																/>
															</span>
															<span className="flex-1">
																<label>{ language[ lang ].process_end_date }</label>
																<input
																	type="text" 
																	name="data_final_processo"  
																	value={ elem.data_final_processo } 
																	data-index={ index } 
																	onChange={handle_change_info_cfps} 
																	readOnly
																/>
															</span>
															<span className="flex-1">
															</span>
														</div>
														{/* <span className="assec-mb-15">
															<span className="button" onClick = {() => removeInputCfp(index) }>
																Remover {elem.nome}
															</span>
														</span> */}
													</div>
												)
											}
										})											
										}
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>

				<div className={'dash-cards-2 footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className="nav-item">
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }} replace>
										<img alt={language[lang].back} src={'./img/seta_2.svg'} />
										<span>{language[lang].back}</span>
									</Link>
								</li>

								<li className={"nav-item " + show_delete_button}>
									<button onClick={apagar} className="nav-link btn-delete">
										<img alt={language[lang].delete} src={'./img/eliminar_b.svg'} />
										<span><span>{language[lang].delete}</span></span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<img alt={language[lang].save} src={'./img/save.svg'} />
										<span><span>{language[lang].save}</span></span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main >
}
